export const Title = ({ children }: { children: React.ReactNode }) => {
  return <h2 className="text-2xl font-bold text-left">{children}</h2>;
};
